export class DropzoneThumbnail {
    name: string;
    size: number;
    url: string;

    constructor(name, size, url) {
        this.name = name;
        this.size = size;
        this.url = url;
    }

}